<template>
	<div>
		<modalsupplier v-model="dialog" :propAdd='paramProp' :val = 'val'/>
		<modalconfirm ref="modalconfirmSupplier" @action="deleteData"/>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Supplier</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-btn light depressed class="primary" @click="() => {dialog=true; paramProp='tambah'; val= {};}">
						<v-icon>mdi-plus-circle</v-icon>
						<div class="pl-2 text-capitalize">Tambah Supplier</div>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn text depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2 text-capitalize">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined>
			<v-data-table loading disable-pagination :headers="headers" :items="supplierResults" :search="search" hide-default-footer :options.sync="option" :server-items-length="supplierPagination.total_data">
				<template v-slot:item.supplier_name="{ item }">
					<div class="pl-2 my-auto">{{ item.supplier_name }}</div>
				</template>
				<template v-slot:item.mobile="{ item }">
					<div class="pb-2">{{ item.supplier_mobilephone }}</div>
				</template>
				<template v-slot:item.email="{ item }">
					<div class="pb-2" v-if="item.supplier_email">{{ item.supplier_email }}</div>
					<div class="pb-2" v-else> - </div>
				</template>
				<template v-slot:item.address="{ item }">
					<div class="pt-2 text-capitalize">{{ item.supplier_address }}, {{item.supplier_subdistrict_name}}, {{item.supplier_city_name}}</div>
					<div class="pb-2 text-capitalize">Prov. {{ item.supplier_province_name }}</div>
				</template>
				<template v-slot:item.supplier_is_active="{ item }">
					<v-switch v-model="item.supplier_is_active" @change="editStatus(item)"></v-switch>
				</template>
				<template v-slot:item.action="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn @click="ubah(item)" class="mr-1" fab dark x-small depressed color="indigo" v-bind="attrs" v-on="on">
								<v-icon dark>mdi-pencil</v-icon>
							</v-btn>
						</template>
						<span>Edit</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn @click.stop="hapus(item.supplier_id, item.supplier_name)" class="" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on">
								<v-icon dark>mdi-delete</v-icon>
							</v-btn>
						</template>
						<span>Hapus</span>
					</v-tooltip>
				</template>
				<template v-slot:progress>
					<div> </div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!supplierPagination">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5">
			<v-row v-if="supplierPagination">
				<v-col cols="12" md="11" class="py-0 d-flex justify-end">
					<v-pagination v-model="page" :length="supplierPagination.total_page" @input="changePage" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="12" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" hide-details class="mt-0" @input="changeLimit" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import modalsupplier from '@/views/MLwarehouse/supplier/ModalSupplier'
import {mapActions,  mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
		modalsupplier
	},
	data() {
		return {
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			propDelete: '',
			paramProp: '',
			paramDelid: '',
			paramDelName: '',
			val: {},
			edit: 'edit',
			dialog: false,
			dialogConfirm: false,
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Nama Supplier', align: 'start', sortable: true, value: 'supplier_name'},
			{ text: 'No. Handphone', value: 'mobile', sortable: false},
			{ text: 'Email', value: 'email', sortable: false},
			{ text: 'Alamat', value: 'address', width: '30%', sortable: false },
			{ text: 'Aktif', value: 'supplier_is_active', sortable: false, },
			{ text: 'Aksi', value: 'action', sortable: false, },
			],
			filterData: [{
				type: 'text',
				label: 'Nama Supplier',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'supplier_name'
				}
			}, {
				type: 'text',
				label: 'No Hp',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'supplier_mobilephone'
				}
			}, {
				type: 'text',
				label: 'Email',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'supplier_email'
				}
			}, {
				type: 'text',
				label: 'Alamat',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'supplier_address'
				}
			},
			],
			params:[],
			paramStatus : {
				id : '',
				status : ''
			}
		}
	},
	props: {
		desserts: Array,
	},
	computed: {
		...mapState('supplierList', ['supplierResults', 'responSukses', 'supplierPagination', 'konfirmResponse']),
	},
	methods: {
		...mapActions('supplierList', ['getSupplier', 'statusSupplier', 'deleteSupplier', 'exportSupplier']),
		...mapMutations('supplierList', ['clearDataSupplier']),
		...mapMutations('maps', ['setLocation']),
		...mapActions('maps', ['getGeolocation']),
		...mapMutations(['setOverlay', 'setFilter']),

		getData() {
			this.getSupplier(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		exportData(){
			this.exportSupplier(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		editStatus(stat){
			this.paramStatus.id = stat.supplier_id
			if(stat.supplier_is_active == false){
				this.paramStatus.status = 'inactive'
			} else{
				this.paramStatus.status = 'active'
			}
			this.statusSupplier(this.paramStatus).then(() => {
				this.getData()
				this.paramStatus.id = ''
				this.paramStatus.status = ''
			})
		},
		hapus(id, name){
			this.propDelete = id
			let msg = `Yakin ingin menghapus ${name}`
			this.$refs.modalconfirmSupplier.setMessage(msg)
			this.$refs.modalconfirmSupplier.showConfirm()
		},
		async deleteData () {
			await this.setOverlay(true)
			await this.$refs.modalconfirmSupplier.hideConfirm()
			await this.deleteSupplier(this.propDelete).then( () => {
				if(this.responSukses.code == 200) {
					this.getData()
				}
			})
			await this.setOverlay(false)
		},
		tambah() {
			this.dialog=true;
			this.paramProp='tambah';
			this.val = {};
		},
		ubah(item){
			this.val = item;
			this.dialog = true;
			this.paramProp ='edit';
			this.setLocation({lat:parseFloat(item.supplier_latitude), lng:parseFloat(item.supplier_longitude)})
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		onResetFilter() {
			this.params = []
			this.getData()
		},
	},
	created() {
		this.setFilter(this.filterData)
		this.getData()
		this.$store.dispatch('setPageTitle', `Supplier`)
		this.getGeolocation();
	},
	beforeDestroy(){
		this.clearDataSupplier()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'DESC' : 'ASC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	}
}
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
.v-avatar .avatar {
	object-position: center;
	object-fit: cover;
}
</style>